import styled from "styled-components";

export const LanguageSwitcherContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;

  @media (max-width: 768px) {
    position: static;
    margin: 16px 0;
  }
`;
